/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Shubham Kumar",
  logo_name: "Shubham Kumar",
  nickname: "zyberg",
  subTitle:
    "Hello,I am an enthusiast in research and development industry of ML.",
  resumeLink:
    "https://drive.google.com/file/d/1AcvmM2gjadxzgNNC4lqn9BAMElt7awFh/view",
  displayGreeting: true,
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/zyberg2091",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/shubham-kumar-7b0a5a16a/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:shubhamkr2091@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/Shubham_2091?s=08",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Working with Computer Vision and NLP projects to build",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    // {
    //   title: "Full Stack Development",
    //   fileName: "FullStackImg",
    //   skills: [
    //     "⚡ Building resposive website front end using React-Redux",
    //     "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
    //     "⚡ Creating application backend in Node, Express & Flask",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "HTML5",
    //       fontAwesomeClassname: "simple-icons:html5",
    //       style: {
    //         color: "#E34F26",
    //       },
    //     },
    //     {
    //       skillName: "CSS3",
    //       fontAwesomeClassname: "fa-css3",
    //       style: {
    //         color: "#1572B6",
    //       },
    //     },
    //     {
    //       skillName: "Sass",
    //       fontAwesomeClassname: "simple-icons:sass",
    //       style: {
    //         color: "#CC6699",
    //       },
    //     },
    //     {
    //       skillName: "JavaScript",
    //       fontAwesomeClassname: "simple-icons:javascript",
    //       style: {
    //         backgroundColor: "#000000",
    //         color: "#F7DF1E",
    //       },
    //     },
    //     {
    //       skillName: "ReactJS",
    //       fontAwesomeClassname: "simple-icons:react",
    //       style: {
    //         color: "#61DAFB",
    //       },
    //     },
    //     {
    //       skillName: "NodeJS",
    //       fontAwesomeClassname: "simple-icons:node-dot-js",
    //       style: {
    //         color: "#339933",
    //       },
    //     },
    //     {
    //       skillName: "NPM",
    //       fontAwesomeClassname: "simple-icons:npm",
    //       style: {
    //         color: "#CB3837",
    //       },
    //     },
    //     {
    //       skillName: "Yarn",
    //       fontAwesomeClassname: "simple-icons:yarn",
    //       style: {
    //         color: "#2C8EBB",
    //       },
    //     },
    //     {
    //       skillName: "Gatsby",
    //       fontAwesomeClassname: "simple-icons:gatsby",
    //       style: {
    //         color: "#663399",
    //       },
    //     },
    //     {
    //       skillName: "Flutter",
    //       fontAwesomeClassname: "simple-icons:flutter",
    //       style: {
    //         color: "#02569B",
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "Cloud Infra-Architecture",
    //   fileName: "CloudInfraImg",
    //   skills: [
    //     "⚡ Experience working on multiple cloud platforms",
    //     "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
    //     "⚡ Deploying deep learning models on cloud to use on mobile devices",
    //     "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "GCP",
    //       fontAwesomeClassname: "simple-icons:googlecloud",
    //       style: {
    //         color: "#4285F4",
    //       },
    //     },
    //     {
    //       skillName: "AWS",
    //       fontAwesomeClassname: "simple-icons:amazonaws",
    //       style: {
    //         color: "#FF9900",
    //       },
    //     },
    //     {
    //       skillName: "Azure",
    //       fontAwesomeClassname: "simple-icons:microsoftazure",
    //       style: {
    //         color: "#0089D6",
    //       },
    //     },
    //     {
    //       skillName: "Firebase",
    //       fontAwesomeClassname: "simple-icons:firebase",
    //       style: {
    //         color: "#FFCA28",
    //       },
    //     },
    //     {
    //       skillName: "PostgreSQL",
    //       fontAwesomeClassname: "simple-icons:postgresql",
    //       style: {
    //         color: "#336791",
    //       },
    //     },
    //     {
    //       skillName: "MongoDB",
    //       fontAwesomeClassname: "simple-icons:mongodb",
    //       style: {
    //         color: "#47A248",
    //       },
    //     },
    //     {
    //       skillName: "Docker",
    //       fontAwesomeClassname: "simple-icons:docker",
    //       style: {
    //         color: "#1488C6",
    //       },
    //     },
    //     {
    //       skillName: "Kubernetes",
    //       fontAwesomeClassname: "simple-icons:kubernetes",
    //       style: {
    //         color: "#326CE5",
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Education Page
const degrees = {
  degrees: [
    {
      title: "SRM Institute of Science and Technology",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "srm.png",
      alt_name: "SRMIST",
      duration: "2018 - Present",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing",
      ],
      website_link: "https://www.srmist.edu.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Python for Everybody",
      subtitle: "- Charles Severance",
      logo_path: "UMC.png",
      alt_name: "University of Michigan",
      color_code: "#0000FF",
    },

    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Practical Machine Learning with Tensorflow",
      subtitle: "- Prof. Ashish Tendulkar",
      logo_path: "nptel_logo.png",
      alt_name: "IIT Madras",
      color_code: "#D83B0199",
    },
    {
      title: "Machine learning A-Z : Hands on Python and R in Data Science",
      subtitle: "- Kirill Eremenko",
      logo_path: "udemy.jpg",
      alt_name: "Udemy",
      color_code: "#FF0000",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Natural Language Processing with Tensorflow",
      subtitle: "- Laurence Moroney ",
      logo_path: "deeplearning_ai_logo.png",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
  ],
};
const achievementSection = {
  title: "Achievements And Certifications",
  subtitle: "Achievements, Certifications in Hackathons",

  achievementsCards: [
    {
      title: "3rd Position in Hackcbs 3.0",
      subtitle:
        "It is an India's largest student run hackathon conducted by MLH. Our team bagged the 3rd position among the participants of 260+ colleges ,2000+ registrations from all around the world.",
      image: "MLH.png",
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/1BAboI2FFpb8SyHjtJbZj8Fz_kgS_iSMR/view",
        },
        {
          name: "Project",
          url: "https://github.com/zyberg2091/Aapka-Apna-Hiphop",
        },
      ],
    },
    {
      title: "3rd Position in HackYuva 2020",
      subtitle:
        "This is a hackathon organized by a startup company learnyuva.our team bagged the 3rd position in this hackathon.we received the prize by myways(a startup) and learnyuva..",
      image: "Learnyuva.jpg",
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/1K-qPg7C0-7EU6nEOy7EDciKsIemQEsZw/view",
        },
        {
          name: "Project link",
          url:
            "https://github.com/zyberg2091/smart-road-safety-security-systems",
        },
      ],
    },

    {
      title: "Top 15 in SLAC 2020",
      subtitle:
        "It is a hackathon conducted by Amritha school of engineering,bangalore every year.we were under top 15 category this year.",
      image: "SLAC.png",
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/1qFF5xeoD2YyL0KvZJ2Z5p4oeNd2AK3o4/view",
        },
        {
          name: "Project Link",
          url: "https://github.com/zyberg2091/Aapka-Apna-Hiphop",
        },
      ],
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};
// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Achievements",
  description:
    "I have worked with evolving startups as ML and DL Developer.I am also an open source enthusiast and i am an active contributor in open source events such as Hacktoberfest.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work/Internships",
      experiences: [
        {
          title: "Research Associate",
          company: "Next Tech Lab,SRM",
          company_url:
            "https://www.linkedin.com/company/next-tech-lab/mycompany/",
          logo_path: "NT.png",
          duration: "March 2020 -April 2021",
          location: "Chennai, Tamil Nadu",
          description:
            "The first and only student run multi-disciplinary lab of SRM University a Chennai founded by a MIT student . Next Tech Lab is the only organization from India to win the QS Reimagine Education 2018 award for their work . I am a member of a mcCarthy lab that deals with the research in Artificial Intelligence",
          color: "#0879bf",
        },
        {
          title: "Data Science Intern",
          company: "Pain free Academy",
          company_url: "https://www.paica.org/",
          logo_path: "Paica.jpg",
          duration: "Sept 2020 - Dec 2020",
          location: "New Delhi, India",
          description:
            "Its an edtech startup.Here i am working in the projects of NLP domain that works across multiple industry verticals and sharing that in the for of articles to the company during the internship.I worked on Neural Image captioning with Visual Attention,implemented the code and wrote the article about the same.",
          color: "#9b1578",
        },
        {
          title: "Data Science Intern",
          company: "The Sparks Foundation",
          company_url: "https://www.thesparksfoundationsingapore.org/",
          logo_path: "spark foundation.png",
          duration: "Sept 2020 - Sept 2020",
          location: "India",
          description:
            "Worked/working with K-means algorithm,decision tree algorithm on a task and bussiness analytics project during 1 month of internship.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Achievements",
      experiences: [
        {
          title: "3rd Position in Hackcbs 3.0",
          description:
            "It is an India's largest student run hackathon conducted by MLH. Our team bagged the 3rd position among the participants of 260+ colleges ,2000+ registrations from all around the world.",
          logo_path: "MLH.png",
        },
        {
          title: "3rd Position in Hachyuva 2020",
          description:
            "This is a hackathon organized by a startup company learnyuva.our team bagged the 3rd position in this hackathon.We received the prize by myways(a startup) and Learnyuva.",
          logo_path: "Learnyuva.jpg",
        },
        {
          title: "Top 15 in SLAC",
          logo_path: "SLAC.png",
          description:
            "It is a hackathon conducted by Amritha School of Engineering,Bangalore every year.We were under top 15 category this year.",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  achievementSection,
  degrees,
  certifications,
  experience,
  projectsHeader,
};
